var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "block-helper",
    },
    [
      _c("courseware-companion-box", {
        attrs: {
          msgCompanion: _vm.currentQuestion.text,
          mood: _vm.companionMood,
        },
      }),
      _vm._v(" "),
      _vm.showBlocks
        ? _c(
            "div",
            {
              staticClass: "cw-block-helper-results",
            },
            _vm._l(_vm.selectedBlockTypes, function (block, index) {
              return _c("courseware-blockadder-item", {
                key: index,
                attrs: {
                  title: block.title,
                  type: block.type,
                  description: block.description,
                },
                on: {
                  blockAdded: _vm.resetQuestions,
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-block-helper-buttons",
        },
        [
          _vm._l(_vm.currentQuestion.responses, function (response, index) {
            return _c(
              "button",
              {
                key: index,
                staticClass: "button",
                on: {
                  click: function click($event) {
                    return _vm.setQuestion(response.answer)
                  },
                },
              },
              [_vm._v("\n            " + _vm._s(response.text) + "\n        ")]
            )
          }),
          _vm._v(" "),
          _vm.currentQuestionId !== "a"
            ? _c(
                "button",
                {
                  staticClass: "button cw-block-helper-reset",
                  on: {
                    click: _vm.resetQuestions,
                  },
                },
                [_c("translate", [_vm._v("Zurücksetzen")])],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }